import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiService } from '../../services/api';
import { flightLinksKeys } from './flightLinks.queries';
import { sharedObjectsKeys } from '../object-shares/sharedObjects.queries';

// STD-015: write actions for linking a .bin log to its flight (#1694).
//
// Both invalidate the link detail AND the shared-objects reach: a link to a
// shared flight adds the log to the grantees' "Shared with me", and an unlink
// removes it. In this browser that is only the outbound side, but the cached
// listing must not keep saying what it said before the change.
const NAMESPACES = [flightLinksKeys.all, sharedObjectsKeys.all];

export function useLinkFlightMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: async ({ objectId, flightId }: { objectId: string; flightId: string }) =>
      apiService.linkFlight(objectId, flightId),
    onSuccess: () => {
      for (const queryKey of NAMESPACES) queryClient.invalidateQueries({ queryKey });
    },
  });
}

export function useUnlinkFlightMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: async ({ objectId, flightId }: { objectId: string; flightId: string }) =>
      apiService.unlinkFlight(objectId, flightId),
    onSuccess: () => {
      for (const queryKey of NAMESPACES) queryClient.invalidateQueries({ queryKey });
    },
  });
}
